/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_TitleInputs */



/**
* | output |
* | --- |
* | "What Wundo brings along" |
*
* @param {Meeting_Sources_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_title = /** @type {((inputs?: Meeting_Sources_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wat Wundo meeneemt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce que Wundo apporte")
	return /** @type {LocalizedString} */ ("What Wundo brings along")
});